import rayPic from "@/public/images/artists/ray.png";
import { Artist } from "@/types/types";

export const ray = {
  id: "224",
  name: "Ray",
  image: rayPic,
  description: `Ray's voice carries the smooth, emotive tone of classic R&B, with a rich falsetto and impressive runs. His falsetto is the standout element of his sound—crisp, bright, and effortlessly smooth. His runs are fluid and precise, gliding from note to note with controlled ease that showcases his vocal agility. Each transition feels natural, with his falsetto adding a layer of airiness and texture that lifts his melodies to new heights.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fray-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: [
        "RnB",
        "Dance",
        "Pop",
        "Falsetto",
        "Unprocessed",
        "Afrobeat",
        "Ballads",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Very high",
      },
      specific: {
        low: 55,
        high: 75,
      },
      sweetSpot: 62,
    },
  },
} as const satisfies Artist;
